import { parseISO } from 'date-fns';
import { format } from 'date-fns';
import moment from 'moment-timezone';
import formatHtml from 'sanitize-html';

import cadreamfund from '../constants/cadreamfund';

export const sanitizeHtml = (unsafeHtml) => {
  return formatHtml(unsafeHtml, {
    allowedTags: ['a', 'del', 'div', 'ins', 'span', 'strong', 'p', 'ol', 'li', 'br', 'b'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      span: ['class'],
      div: ['class'],
      strong: ['class'],
      p: ['class'],
    },
  });
};
export const sanitizeHtmlNoLink = (unsafeHtml) => {
  return formatHtml(unsafeHtml, {
    allowedTags: ['del', 'div', 'ins', 'span', 'strong', 'p', 'ol', 'li', 'br', 'b'],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      span: ['class'],
      div: ['class'],
      strong: ['class'],
      p: ['class'],
    },
  });
};

export const formatPhoneNumber = (str) => {
  const cleaned = ('' + str).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return ['+1', '-', match[2], '-', match[3], '-', match[4]].join('');
  }

  return null;
};

export const truncateEmail = (str) => {
  const dotPos = str.indexOf('.');
  if (dotPos > 6) {
    return str.substr(0, 3) + '***' + str.substr(dotPos - 3, 3) + str.substr(dotPos);
  }
  return str;
};

// format number 1000000 to 1,234,567
export const formatNumber = (type, value) => {
  if (type == 'numberInput') return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  else {
    return value.replace(/\D/g, '');
  }
};

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export const formatOptionName = (label, key) => {
  const validKey = escapeRegExp(key);
  const re = new RegExp(`(${validKey})`, 'i');
  return label && label.replace(re, '<strong styles="color: #000; font-weight: 500;">$1</strong>');
};

export const formatOptionDescription = (text, key) => {
  const validKey = escapeRegExp(key);
  const re = new RegExp(`(${validKey})`, 'i');
  return text && text.replace(re, '<strong styles="color: #000; font-weight: 500;">$1</strong>');
};

export const formatUSDCurrency = (value, fractionDigits = 2, digitsRequired = false) => {
  if (!value) {
    value = '0';
  }

  if (value % 1 == 0 && !digitsRequired) {
    const intFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return intFormatter.format(value);
  } else {
    const fractionFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
    return fractionFormatter.format(value);
  }
};

export const formatPercent = (value) => {
  if (!value) {
    return '0%';
  }

  if (value % 1 == 0) {
    const intFormatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    intFormatter.format(value);
  } else {
    const fractionFormatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return fractionFormatter.format(value);
  }
};
export const capitalizeFirstLetter = (string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
};

export const kFormatter = (num) => {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
    : Math.sign(num) * Math.abs(num);
};

export const isCurrentDateInDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) {
    return true;
  } else {
    const currrentDate = new Date();
    const futureDate = new Date();
    futureDate.setDate(currrentDate.getDate() + 10);
    const pasteDate = new Date();
    pasteDate.setDate(currrentDate.getDate() - 1);
    const lStartDate = startDate ? parseISO(startDate) : pasteDate;
    //if endDate is not defined we use a future date
    const lEndDate = endDate ? parseISO(endDate) : futureDate;

    if (
      currrentDate.getTime() < lEndDate.getTime() &&
      currrentDate.getTime() > lStartDate.getTime()
    ) {
      return true;
    } else {
      return false;
    }
  }
};

export const notificationTextCurrentDateInDateRange = (startDate, endDate, timeZone, suffix) => {
  if (!startDate) {
    return false;
  } else {
    const lStartDate = parseISO(startDate);
    const currrentDate = new Date();
    const futureDate = new Date();
    futureDate.setDate(currrentDate.getDate() + 10);
    //if endDate is not defined we use a future date
    const lEndDate = endDate ? parseISO(endDate) : futureDate;

    if (currrentDate.getTime() < lStartDate.getTime()) {
      return {
        text: `${cadreamfund.notificationText.startTime} ${format(
          lStartDate,
          'MMM d, y'
        )} at  ${moment.tz(lStartDate, timeZone).format('h:mm:ss a')} ${suffix}`,
      };
    }
    if (currrentDate.getTime() > lEndDate) {
      return { text: cadreamfund.notificationText.timeIsUp };
    }
    return false;
  }
};

export const checkIsOfferExpired = (endDate) => {
  if (!endDate) {
    return false;
  } else {
    const lEndDate = parseISO(endDate);
    const currrentDate = new Date();

    if (currrentDate.getTime() > lEndDate.getTime()) {
      return true;
    } else {
      return false;
    }
  }
};
